import React from "react";
import HyroLoader from "@hyro-components/HyroLoader";
import { HYRO_ADMIN_PANEL_ACCOUNT_ID } from "@consts";
import { useMyAccountPermissions } from "src/queries/hooks/permissions";
import ForbiddenErrorPage from "../ErrorPages/forbidden-error-page/ForbiddenErrorPage";
import GenericErrorPage from "../ErrorPages/GenericErrorPage";
import NotFoundErrorPage from "../ErrorPages/NotFoundErrorPage";
import UnauthorizedErrorPage from "../ErrorPages/UnauthorizedErrorPage";

const AccountAccessGate = ({ accountId, children }) => {
  const isAdminPanelPseudoAccount = accountId === HYRO_ADMIN_PANEL_ACCOUNT_ID;
  const { isPending, isError, error } = useMyAccountPermissions(isAdminPanelPseudoAccount ? null : accountId);

  if (isAdminPanelPseudoAccount) return <NotFoundErrorPage />;
  if (isPending) return <HyroLoader height="100vh" />;

  if (!isError) return children;

  switch (error?.response?.status) {
    case 404:
      return <NotFoundErrorPage />;
    case 403:
      return <ForbiddenErrorPage />;
    case 401:
      return <UnauthorizedErrorPage />;
    default:
      return <GenericErrorPage />;
  }
};

export default AccountAccessGate;
